/* eslint-disable */
// Funções compartilhadas de busca/normalização de relatórios,
// usadas pelo chat da tela inicial, pelo command palette e pela sidebar.

export function normalizarTexto(texto) {
  return (texto || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

export function flattenMenus(menus) {
  const lista = Array.isArray(menus) ? menus : Object.values(menus || {})
  const links = []

  lista.forEach(menu => {
    (menu.links || []).forEach(link => {
      links.push({ ...link, ds_nome: menu.ds_nome })
    })
  })

  return links
}

export function buscarRelatorios(links, texto) {
  const termo = normalizarTexto(texto)
  if (!termo) return []

  const palavras = termo.split(/\s+/).filter(p => p.length > 1)

  return links.filter(link => {
    const nomeLink = normalizarTexto(link.ds_link)

    if (nomeLink.includes(termo) || termo.includes(nomeLink)) {
      return true
    }

    return palavras.some(p => nomeLink.includes(p))
  })
}

export function tempoRelativo(timestamp) {
  if (!timestamp) return ''

  const diffMs = Date.now() - timestamp
  const minutos = Math.floor(diffMs / 60000)

  if (minutos < 1) return this.$t('agora')
  if (minutos < 60) return `${this.$t('ha')} ${minutos} ${this.$t('minutos')}`

  const horas = Math.floor(minutos / 60)
  if (horas < 24) return `${this.$t('ha')} ${horas} ${this.$t('horas')}`

  const dias = Math.floor(horas / 24)
  if (dias === 1) return this.$t('ontem')
  if (dias < 7) return `${this.$t('ha')} ${dias} ${this.$t('dias')}`

  const semanas = Math.floor(dias / 7)
  return `${this.$t('ha')} ${semanas} ${this.$t('semanas')}`
}